<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Rest Hour Setting &nbsp;
          <add-button
            link="/rest-hours-management/rest-hour-settings/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Rest Hours Management</li>
          <li class="breadcrumb-item">Rest Hour Setting</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportrest_hour_settings.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="rest_hour_settings_excel"
                    :fields="excel_fields"
                    worksheet="Rest Hour Setting"
                    name="Rest Hour Setting.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Default 24 Hours Calculation</th>
                    <th>Compliace</th>
                    <th>Copy working arrangement</th>
                    <th>Copy From</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="rest_hour_settings.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(rest_hour_setting, at) in rest_hour_settings"
                    :key="`rest-hour-setting${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ rest_hour_setting.hour_calculation.name }}</td>
                    <td>{{ rest_hour_setting.compliance.name }}</td>
                    <td>
                      {{
                        rest_hour_setting.is_copy_working == true ? "Yes" : "No"
                      }}
                    </td>
                    <td>{{ rest_hour_setting.copy_from }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/rest-hours-management/rest-hour-settings/${rest_hour_setting.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(rest_hour_setting.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "rest_hour_setting",
  data() {
    return {
      rest_hour_settings: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      rest_hour_settings_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Default 24 Hours Calculation": "hour_calculation",
        Compliace: "compliance",
        "Copy Working Arrangement": "is_copy_working",
        "Copy From": "copy_from",
        "Save non conformity working arrangement:": "is_non_conformity",
        "Hours in Any 7 days columns": "is_hour_in_any_7day",
        "Confirmation on save non conformity":
          "is_confirmation_save_non_conformity",
        "NC time based on": "nc_time_based_on",
        "NC marking": "nc_marking",
        "Maximum Rest hour breaks validation in a day (No more than 2 breaks)":
          "is_max_rest_hr_break_validation",
        "Rest hours NC alert days duration": "rest_hour_nc_alert_day_duration",
        "Include Foot notes in Reports": "is_foot_note",
        "Foot Report": "foot_note",
        "Editable Crew general data in Vessel":
          "is_editable_crew_general_data_vessel",
      },
      Exportrest_hour_settings: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let rest_hour_settings = await axios.get(
        `/rest_hour_settings?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.rest_hour_settings = rest_hour_settings.data.data;
      this.count = rest_hour_settings.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let rest_hour_settings = await axios.get(
        `/rest_hour_settings?search=${this.searchData}`
      );
      this.rest_hour_settings = rest_hour_settings.data.data;
      this.count = rest_hour_settings.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Rest Hour Setting Data";
      this.rest_hour_settings_excel = [];
      let Exportrest_hour_settings = [];
      Exportrest_hour_settings = await axios.get(`/rest_hour_settings`);
      this.Exportrest_hour_settings = Exportrest_hour_settings.data.data;
      let sr_no = 1;
      this.Exportrest_hour_settings.forEach((rest_hour_setting) => {
        this.rest_hour_settings_excel.push({
          sr_no: sr_no,
          copy_from: rest_hour_setting.copy_from
            ? rest_hour_setting.copy_from
            : "",
          nc_time_based_on: rest_hour_setting.nc_time_based_on
            ? rest_hour_setting.nc_time_based_on
            : "",
          nc_marking: rest_hour_setting.nc_marking
            ? rest_hour_setting.nc_marking
            : "",
          rest_hour_nc_alert_day_duration:
            rest_hour_setting.rest_hour_nc_alert_day_duration
              ? rest_hour_setting.rest_hour_nc_alert_day_duration
              : "",
          foot_note: rest_hour_setting.foot_note
            ? rest_hour_setting.foot_note
            : "",

          hour_calculation: rest_hour_setting.hour_calculation
            ? rest_hour_setting.hour_calculation.name
            : "",
          compliance: rest_hour_setting.compliance
            ? rest_hour_setting.compliance.name
            : "",

          is_copy_working:
            rest_hour_setting.is_copy_working == true ? "Yes" : "No",
          is_non_conformity:
            rest_hour_setting.is_non_conformity == true ? "Yes" : "No",
          is_hour_in_any_7day:
            rest_hour_setting.is_hour_in_any_7day == true ? "Yes" : "No",
          is_confirmation_save_non_conformity:
            rest_hour_setting.is_confirmation_save_non_conformity == true
              ? "Yes"
              : "No",
          is_max_rest_hr_break_validation:
            rest_hour_setting.is_max_rest_hr_break_validation == true
              ? "Yes"
              : "No",
          is_foot_note: rest_hour_setting.is_foot_note == true ? "Yes" : "No",
          is_editable_crew_general_data_vessel:
            rest_hour_setting.is_editable_crew_general_data_vessel == true
              ? "Yes"
              : "No",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=rest_hour_settings`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
